import { useEffect, useState } from "react";
import moment from "moment";
import { getDashboardTrainingClassesMonthlyGraph } from "../../../appRedux/actions";
import { Col, DatePicker, Row, Select, Space } from "antd";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
const { RangePicker } = DatePicker;

export default function BarChartMonthlyClasses({ trainingOptions, locations }) {
  const [filter, setFilter] = useState({
    training_option_id: null,
    start_date: moment().startOf('year').toISOString(),
    end_date: moment().endOf('year').toISOString(),
    location: null,
    classes: null,
    category_id: null,
  })
  let options = [
    { value: null, label: "Semua Lokasi" },
    { value: "Online", label: "Online" },
    { value: "Offline", label: "Offline" },
  ]
  if (locations)
    locations.map(location => {
      options.push({ value: location, label: location })
    })
  let trainingCategories = []
  trainingOptions.map(trainingOption => {
    trainingCategories.push({
      value: trainingOption.training_category_id,
      label: trainingOption.training_category.name,
    })
  })
  trainingCategories = trainingCategories.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.value === value.value && t.label === value.label
    ))
  )
  trainingCategories.sort((a, b) => {
    return sortOptions(a, b)
  })
  trainingCategories = [{
    value: null, label: "Semua Kategori"
  }].concat(trainingCategories)

  let trainingsOptions = []
  trainingOptions.map(trainingOption => {
    trainingsOptions.push({
      value: trainingOption.id,
      label: trainingOption.name,
      category_id: trainingOption.training_category_id
    })
  })
  trainingsOptions.sort((a, b) => {
    return sortOptions(a, b)
  })
  trainingsOptions = [{
    value: null, label: "Semua Training", category_id: null
  }].concat(trainingsOptions)

  function sortOptions(a, b) {
    const nameA = a.label.toUpperCase();
    const nameB = b.label.toUpperCase();
    if (nameA < nameB)
      return -1;
    if (nameA > nameB)
      return 1;
    return 0;
  }

  const [data, setData] = useState([])

  useEffect(() => {
    getDashboardTrainingClassesMonthlyGraph(filter).then((rows) => {
      setData(rows)
    })
  }, []);

  function handleChangeFilter(filter) {
    setFilter(filter)
    getDashboardTrainingClassesMonthlyGraph(filter).then((rows) => {
      setData(rows)
    })
  }

  const getClassesMonthlyData = () => {
      let list = []
      data.map((data) => {
        list.push({
          name: moment(data.month_year).format("MMMM YYYY"),
          total: data.total,
        })
      })
      return list
    }

  return <>
    <Row wrap gutter={[16, 16]} justify="space-between">
      <Col>
        <Space wrap>
          <RangePicker
            picker={"month"}
            value={[moment(filter.start_date), moment(filter.end_date)]}
            onChange={(values) => {
              handleChangeFilter({ ...filter, start_date: moment(values[0]).toISOString(), end_date: moment(values[1]).toISOString() })
            }}
          />
          <Select
            value={filter.location}
            dropdownMatchSelectWidth={true}
            onChange={(v) => {
              handleChangeFilter({ ...filter, location: v })
            }}
            // style={{ borderRadius: 0, width: 100 }}
            options={options}
          ></Select>
          <Select
            value={filter.category_id}
            dropdownMatchSelectWidth={true}
            onChange={(v) => {
              handleChangeFilter({ ...filter, category_id: v, training_option_id: null })
            }}
            style={{ borderRadius: 0, width: 140 }}
            options={trainingCategories}
          ></Select>
          <Select
            showSearch
            value={filter.training_option_id}
            dropdownMatchSelectWidth={true}
            onChange={(v) => {
              handleChangeFilter({ ...filter, training_option_id: v })
            }}
            style={{ borderRadius: 0, width: 200 }}
            options={trainingsOptions.filter((training) => {
              if (!filter.category_id || !training.value)
                return true
              if (filter.category_id == training.category_id)
                return true
            })}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          ></Select>
          <Select
            showSearch
            value={filter.classes}
            dropdownMatchSelectWidth={false}
            onChange={(v) => {
              handleChangeFilter({ ...filter, classes: v })
            }}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Select.Option value={null}>Semua Kelas</Select.Option>
            <Select.Option value="running">Kelas Berjalan</Select.Option>
            <Select.Option value="canceled">Kelas Cancel</Select.Option>
          </Select>
        </Space>
      </Col>
    </Row>
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        data={getClassesMonthlyData()}
        margin={{ top: 10, right: 0, left: -15, bottom: 0 }}
      >
        <XAxis dataKey={"name"} />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Bar dataKey={"total"} fill={"#003366"} name={"Jumlah Kelas"} />
      </BarChart>
    </ResponsiveContainer>
  </>
}